
import { DataTable } from "primereact/datatable";
import cube from "../../assets/Forecast-cube.png";
import { Column } from "primereact/column";
import { InputNumber } from 'primereact/inputnumber';
import { useEffect, useState } from "react";
import SegmentationDetails from "./segmentation-details";
import CustomLoader from "../../common/CustomLoader/CustomLoader";
import { useGetSegmentationDataQuery } from "../../services/redux/api/forecastSegmentationApi";
import { SegmentData, SegmentDetailPayload } from "../../services/interface/IForecastSegmentation";
import { useDispatch, useSelector } from "react-redux";
import { FilterConfig, IDemandPayload, IRoot } from "../../services/interface/IDemand";
import { useForecastOverViewDropDownFilter } from "../../services/redux/hooks/useDemand";
import { setDBFilter, setSelectedDBFilter } from "../../services/redux/reducer/demandfilter.reducer";
import DemandForecastFilter from "../../components/Filter/demandForecastFilter";

const ForecastSegmentation = () => {

    const { data, isLoading, isError } = useGetSegmentationDataQuery(null);
    const [showDetails, setShowDetails] = useState<boolean>(false);
    const [segmentDataCopy, setSegmentDataCopy] = useState<SegmentData[] | null>([] as SegmentData[]);
    const [selectedSegment, setSelectedSegment] = useState<SegmentData>({} as SegmentData);
    const isApplied = useSelector((state: IRoot) => state.dbfilter.applyFilter);
    const biasFlag = useSelector((state: IRoot) => state.dbfilter.biasFlag)

    const [detailPayload, setDetailPayload] = useState<SegmentDetailPayload>({} as SegmentDetailPayload);
    const initialState: IDemandPayload = {
        dc: [],
        storeNumber: [],
        itemId: [],
        fcwNumber: ["3"],
        ucode: [],
        productSegm: [],
        productDesc: [],
        category: [],
        subCategory: [],
        vendorName: [],
        modelType: ["error based best model"],
    }
    const dispatch = useDispatch();
    const [loading, setLoading] = useState<boolean>(false);
    // filter api - data
    const [filter, setFilter] = useState<IDemandPayload>(initialState);
    // selected filter - data
    const [selectedFilterData, setSelectedFilterData] = useState<IDemandPayload>(initialState);
    // selected filter - redux
    const selectedDbFilter = useSelector((state: IRoot) => state.dbfilter.selectedDbFilter);
    // 

    useEffect(() => {
        if (data?.segmentData.length > 0)
            setSegmentDataCopy(JSON.parse(JSON.stringify(data.segmentData)));
    }, [data])

    useEffect(() => {
        if (isApplied === 'applied') {
            setDetailPayload({
                dc: selectedDbFilter.dc,
                ucode: selectedDbFilter.ucode,
                productSegm: selectedDbFilter.productSegm,
                productDesc: selectedDbFilter.productDesc,
                category: selectedDbFilter.category,
                subCategory: selectedDbFilter.subCategory,
                itemId: selectedDbFilter.itemId ?? [],
                segment: [selectedSegment.Segment],
                biasFlag: biasFlag,
                vendor: selectedDbFilter.vendorName
            })
        }
    }, [isApplied])

    // Filters
    const { mutate: mutateDropDown, data: resFilterData } = useForecastOverViewDropDownFilter();

    // Filters - Start
    const filters: FilterConfig[] = [
        { title: 'DC', key: 'dc', placeholder: 'All' },
        // { title: 'Retail Store', key: 'storeNumber', placeholder: 'All' },
        { title: 'Category', key: 'category', placeholder: 'All' },
        { title: 'SubCategory', key: 'subCategory', placeholder: 'All' },
        { title: 'Segmentation', key: 'productSegm', placeholder: 'All' },
        { title: 'Product Desc.', key: 'productDesc', placeholder: 'All' },
        { title: 'Item Id', key: 'itemId', placeholder: 'All' },
        // { title: 'Forecast Week', key: 'fcwNumber', placeholder: '3', isSelectPicker: true },
        { title: 'Vendor', key: 'vendorName', placeholder: 'All' },
    ];

    const filterHandler = async () => {
        setLoading(true);
        try {
            await mutateDropDown(selectedFilterData);
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setLoading(false);
        }
    }

    const setFilterData = () => {
        if (resFilterData?.data) {
            setFilter(resFilterData?.data);
            dispatch(setDBFilter(resFilterData?.data));
        }
    }

    const filterSelectionHandler = (key: any, value: any) => {
        setSelectedFilterData({
            ...selectedFilterData,
            [key]: value
        });
    }

    const removeSelectionHandler = () => {
        setSelectedFilterData(initialState);
    }
    // Filters - End

    useEffect(() => {
        dispatch(setSelectedDBFilter(selectedFilterData));
    }, [selectedFilterData]);

    useEffect(() => {
        setFilterData();
        return () => {
            dispatch(setSelectedDBFilter(initialState));
        }
    }, [resFilterData?.data]);

    return (
        <>
            {(isLoading || loading) && <CustomLoader open={true} />}
            <div className="flex flex-col justify-start items-start gap-[2vh] bg-[#f1f1f1] w-full h-[88vh] pb-[2vh]">
                {!showDetails && <div className="bg-white border-b-[1px] shadow px-[2vw] py-3 w-full">
                    <h3 className="page-title font-semibold">Demand Forecasting {'>'} <span onClick={() => setShowDetails(false)}>Forecast Segmentation</span></h3>
                </div>}
                {showDetails && <div className="relative w-full bg-white">
                    <h3 className="px-[2vw] pt-3 text-fs20 font-semibold">Demand Forecasting {'>'} <span className="underline underline-offset-2 text-blue-500" onClick={() => {
                        setShowDetails(false);
                        setDetailPayload({} as SegmentDetailPayload);
                        setSelectedFilterData(initialState);
                    }}><a href="" onClick={($event) => { $event.preventDefault() }}>Forecast Segmentation</a></span> {`> Segment ${selectedSegment.Segment}`}</h3>
                    <DemandForecastFilter
                        selectedFilterData={selectedFilterData}
                        filterSelectionHandler={filterSelectionHandler}
                        removeSelectionHandler={removeSelectionHandler}
                        resFilterData={filter}
                        filters={filters}
                        filterHandler={filterHandler}
                        alertDesc="Forecast Segmentation"
                        biasFilterRqd={true}
                        lastUpdated={""} />
                </div>}
                <div className="w-full h-full px-[2vw] flex flex-col justify-start items-start gap-2">
                    {!showDetails && <div className="grow w-full h-full flex flex-row justify-start items-center self-center gap-2 px-[2vw] shadow rounded border-[1px] border-[#bebebe] bg-white">
                        {segmentDataCopy && segmentDataCopy.length > 0 &&
                            <><div className="basis-1/3 shrink grow-0">
                                <img className="w-3/4 pointer-events-none" src={cube}></img>
                            </div>
                                < div className="w-full h-full forecast-segmentation-table py-[2vh]">
                                    <DataTable
                                        className="h-full"
                                        value={segmentDataCopy}
                                        stripedRows
                                        showGridlines
                                        emptyMessage="No records found"
                                    >
                                        <Column
                                            field="Segment"
                                            header="Segment"
                                            body={(rowdata: SegmentData) => {
                                                return (
                                                    <div className="flex items-center">{rowdata.Segment}</div>
                                                )
                                            }}
                                        ></Column>

                                        <Column
                                            field="SegmentDescription"
                                            header="Description"
                                        ></Column>

                                        <Column
                                            field="ForecastStrategy"
                                            header="Forecast Strategy"
                                        ></Column>

                                        <Column
                                            field="Location_Item_Count"
                                            header="Location Item Count"
                                            body={(rowdata: SegmentData) => {
                                                return (
                                                    <div className="flex items-center">{rowdata.Location_Item_Count}</div>
                                                )
                                            }}
                                        ></Column>

                                        <Column
                                            field="Current_Accuracy"
                                            header="Current Accuracy"
                                            body={(rowdata: SegmentData) => {
                                                return (
                                                    <div className="flex items-center">{(rowdata.Current_Accuracy * 100).toFixed(1)}%</div>
                                                )
                                            }}
                                        ></Column>

                                        <Column
                                            field="Current_BIAS"
                                            header="Current BIAS"
                                            body={(rowdata: SegmentData) => {
                                                return (
                                                    <div className="flex items-center">{(rowdata.Current_BIAS * 100).toFixed(1)}%</div>
                                                )
                                            }}
                                        ></Column>

                                        <Column
                                            header={() => {
                                                return (<div className="flex">Allowed BIAS (%)</div>)
                                            }}
                                            body={(rowdata: SegmentData) => {
                                                return (
                                                    <div className="flex gap-2 justify-between items-center">
                                                        <InputNumber onValueChange={(event) => {
                                                            setSegmentDataCopy(segmentDataCopy.map((data: SegmentData) => {
                                                                if (data.Segment === rowdata.Segment) {
                                                                    data.MinAllowedBIAS = (event.value || 0) / 100;
                                                                }
                                                                return data;
                                                            }))
                                                        }} className="custom-input-number" min={-100} max={100} maxFractionDigits={1} value={rowdata.MinAllowedBIAS * 100} suffix="%"></InputNumber>

                                                        <InputNumber onValueChange={(event) => {
                                                            setSegmentDataCopy(segmentDataCopy.map((data: SegmentData) => {
                                                                if (data.Segment === rowdata.Segment) {
                                                                    data.MaxAllowedBIAS = (event.value || 0) / 100;
                                                                }
                                                                return data;
                                                            }))
                                                        }} className="custom-input-number" min={-100} max={100} maxFractionDigits={1} value={rowdata.MaxAllowedBIAS * 100} suffix="%"></InputNumber>
                                                    </div>
                                                )
                                            }}
                                        >
                                        </Column>

                                        <Column
                                            header="Details"
                                            body={(rowdata) => {
                                                return (
                                                    // <button onClick={() => setShowDetails(true)}>View Details</button>
                                                    <span onClick={() => {
                                                        if (rowdata.MinAllowedBIAS < rowdata.MaxAllowedBIAS) {
                                                            setSelectedSegment(rowdata);
                                                            setShowDetails(true);
                                                        }
                                                    }} className={`flex justify-start items-center text-white bg-deloitteGreen px-[2vh] py-[1vh] rounded-md ${rowdata.MinAllowedBIAS >= rowdata.MaxAllowedBIAS ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}>
                                                        <span className="font-bold text-fs14 flex w-full">View</span>
                                                    </span>
                                                )
                                            }}
                                        ></Column>

                                    </DataTable>
                                </div>
                            </>
                        }

                    </div>}

                    {showDetails && <SegmentationDetails segment={selectedSegment} payload={detailPayload}></SegmentationDetails>}
                </div>
            </div >
        </>
    )
}

export default ForecastSegmentation;